import get from 'lodash/get';

export default function isUnleashFeatureFlagReady(state) {
  return get(state, ['unleashFeatureFlags', 'isReady'], false);
}
